<template>
  <div>
    <v-card class="ml-1 mr-1 generic-card" style="border-radius: 20px; margin: 0; margin-top: 5px">
      <template v-if="generic">
        <div class="card-img">
          <uploadfile
            v-model="generic.image_url"
            v-validate="isValidate ? 'required' : ''"
            :height="ratio == 'horizontal' ? 157 : 300"
            data-vv-as="NTN Image"
            :data-vv-name="'generic_manage_' + '_image'"
            @onUploaded="onUploaded"
          ></uploadfile>
        </div>
        <div
          :class="{ 'has-error': errors.has('generic_manage_' + '_image') }"
          style="padding: 0 10px"
        >
          <span v-show="errors.has('generic_manage_' + '_image')" class="error--text caption">{{
            errors.first('generic_manage_' + '_image')
          }}</span>
        </div>

        <div class="card-body">
          <div
            :class="{ 'has-error': errors.has('generic_manage_' + '_title') }"
            style="padding: 5px"
          >
            <textarea
              id="title"
              v-model="generic.title"
              v-validate="isValidate ? 'required' : ''"
              name="title"
              style="
                width: 100%;
                resize: none;
                height: 50px;
                font-weight: 600;
                border-radius: 2px 2px 2px 0px !important;
              "
              maxlength="65"
              :data-vv-as="$t('Title')"
              :data-vv-name="'generic_manage_' + '_title'"
              class="form-control"
              :placeholder="$t('Enter Title')"
              @change="$emit('input', generic)"
            ></textarea>
            <span v-show="errors.has('generic_manage_' + '_title')" class="error--text caption">{{
              errors.first('generic_manage_' + '_title')
            }}</span>
          </div>
        </div>
      </template>

      <ul v-if="generic" class="list-group list-group-flush" style="margin-bottom: 0px">
        <li
          class="list-group-item"
          style="
            border-left: none;
            border-right: none;
            border-bottom: none;
            border-top: 1px solid #eee;
            border-radius: 0px;
            text-align: center;
          "
        ></li>
        <li
          class="list-group-item"
          style="
            border-left: none;
            border-right: none;
            border-bottom: none;
            border-top: 1px solid #eee;
            border-radius: 0px;
            text-align: center;
          "
        >
          <div style="padding: 10px 0">
            <span class="primary--text" style="padding: 15px 0; display: inline">
              {{ $t('receive_messages_every_day') }}
            </span>
          </div>
        </li>
      </ul>
    </v-card>
    <v-dialog v-model="showModal" persistent max-width="600px">
      <v-card>
        <div class="text-xs-right">
          <v-spacer></v-spacer>
          <v-btn flat icon small fab @click="showModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <h3>{{ $t('Link image url') }}</h3>
          <div class="text-xs-center">
            <v-radio-group
              v-model="generic.notification_messages_frequency"
              color="primary"
              row
              class="text-xs-center"
              @select="onSelected"
            >
              <v-radio color="primary" :label="$t('DAILY')" :value="'DAILY'"></v-radio>
              <v-radio color="primary" :label="$t('WEEKLY')" :value="'WEEKLY'"></v-radio>
              <v-radio color="primary" :label="$t('MONTHLY')" :value="'MONTHLY'"></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import uploadfile from '@/components/elements/uploadfile'

export default {
  components: {
    uploadfile
  },
  inject: ['$validator'],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      default: {}
    },
    isValidate: {
      default: false,
      type: Boolean
    },
    ratio: {
      type: String,
      default: 'horizontal'
    }
  },
  data: function () {
    return {
      btnOptions: [
        {
          value: 'DAILY'
        },
        {
          value: 'WEEKLY'
        },
        {
          value: 'MONTHLY'
        }
      ],
      linktype: 'none',
      linkurl: '',
      isProductview: false,
      generic: this.value,
      showModal: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    value: function () {
      this.generic = this.value
    }
  },
  mounted: function () {
    this.generic.notification_messages_frequency = 'DAILY'
  },
  methods: {
    onSelected(param) {
      this.generic.notification_messages_frequency = param
    },

    onUploaded(url) {
      if (this.linktype == 'imglink') {
        this.$set(this.generic, 'default_action', {
          type: 'web_url',
          url: url
        })
        this.linkurl = url
      }
      this.$emit('onSave', this.generic)
    },

    onSave: function () {
      this.$emit('onSave', this.generic)
      this.showModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/NtnManage.vue